module.exports = __webpack_public_path__ + "img/project2.2f56eb70.jpg";